import { render, staticRenderFns } from "./advertiseManage.vue?vue&type=template&id=506bca0e&scoped=true"
import script from "./advertiseManage.vue?vue&type=script&lang=js"
export * from "./advertiseManage.vue?vue&type=script&lang=js"
import style0 from "./advertiseManage.vue?vue&type=style&index=0&id=506bca0e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506bca0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506bca0e')) {
      api.createRecord('506bca0e', component.options)
    } else {
      api.reload('506bca0e', component.options)
    }
    module.hot.accept("./advertiseManage.vue?vue&type=template&id=506bca0e&scoped=true", function () {
      api.rerender('506bca0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_homeCloudPlatform/advertise/advertiseManage.vue"
export default component.exports